import { useState, useEffect } from "react";
import Cookies from "js-cookie";

const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const token = Cookies.get("jweToken");
    return !!token;
  });

  useEffect(() => {
    const token = Cookies.get("jweToken");
    setIsAuthenticated(!!token);
  }, []);

  const login = (token) => {
    Cookies.set("jweToken", token, { expires: 7, path: "/" });
    setIsAuthenticated(true);
  };

  const logout = () => {
    Cookies.remove("jweToken", { path: "/" });
    setIsAuthenticated(false);
  };

  return { isAuthenticated, login, logout };
};

export default useAuth;
